import { Layout } from '@/views/trade';

export default {
    path: '/trade',
    component: Layout,
    children: [
        { path: 'dashboard', component: () => import('@/views/trade/TradeOrderDashboard.vue') },
        { path: 'add', component: () => import('@/views/trade/Add.vue') },
    ]
};
